// The four brand badges the carriers speak, keyed by card-validator's
// type vocabulary. An unknown or missing brand renders the empty badge —
// same footprint, nothing to say (records that predate brand stamping).

import type React from "react";

const BADGE_CLASS = "h-6 w-[34px] flex-none";

function VisaIcon() {
  return (
    <svg
      className={BADGE_CLASS}
      viewBox="0 0 34 24"
      fill="none"
      aria-hidden="true"
    >
      <rect x="0.5" y="0.5" width="33" height="23" rx="3.5" fill="white" />
      <rect x="0.5" y="0.5" width="33" height="23" rx="3.5" stroke="#E5E5E5" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.751 15.8582H8.69129L7.14674 9.79235C7.07343 9.51332 6.91776 9.26664 6.68879 9.15038C6.11737 8.85821 5.4877 8.62568 4.80078 8.50841V8.27487H8.11886C8.57681 8.27487 8.92026 8.62568 8.97751 9.0331L9.77891 13.4086L11.8376 8.27487H13.8401L10.751 15.8582ZM14.9853 15.8582H13.04L14.6418 8.27484H16.5871L14.9853 15.8582ZM19.1035 10.3757C19.1607 9.96725 19.5042 9.73372 19.9049 9.73372C20.5346 9.67508 21.2205 9.79235 21.7929 10.0835L22.1364 8.45079C21.5639 8.21725 20.9343 8.09998 20.3628 8.09998C18.4748 8.09998 17.101 9.15038 17.101 10.6082C17.101 11.7173 18.0741 12.2996 18.761 12.6504C19.5042 13.0002 19.7904 13.2337 19.7332 13.5835C19.7332 14.1082 19.1607 14.3418 18.5893 14.3418C17.9024 14.3418 17.2155 14.1669 16.5868 13.8747L16.2433 15.5084C16.9303 15.7996 17.6734 15.9169 18.3603 15.9169C20.4773 15.9745 21.7929 14.9251 21.7929 13.35C21.7929 11.3664 19.1035 11.2502 19.1035 10.3757ZM28.6005 15.8582L27.0559 8.27484H25.3969C25.0534 8.27484 24.71 8.50838 24.5955 8.85818L21.7354 15.8582H23.7379L24.1375 14.7502H26.598L26.827 15.8582H28.6005ZM25.6837 10.3171L26.2551 13.1751H24.6533L25.6837 10.3171Z"
        fill="#172B85"
      />
    </svg>
  );
}

function MastercardIcon() {
  return (
    <svg
      className={BADGE_CLASS}
      viewBox="0 0 34 24"
      fill="none"
      aria-hidden="true"
    >
      <rect x="0.5" y="0.5" width="33" height="23" rx="3.5" fill="white" />
      <rect x="0.5" y="0.5" width="33" height="23" rx="3.5" stroke="#E5E5E5" />
      <path
        d="M21.5771 5.02997C25.322 5.02997 28.3584 8.02986 28.3584 11.7302C28.3583 15.4304 25.322 18.4304 21.5771 18.4304C19.8982 18.4303 18.3629 17.8256 17.1787 16.8268C15.9945 17.8254 14.4591 18.4304 12.7803 18.4304C9.03566 18.4301 6.00011 15.4302 6 11.7302C6 8.02999 9.03559 5.03019 12.7803 5.02997C14.459 5.02997 15.9945 5.63405 17.1787 6.63251C18.3628 5.63388 19.8984 5.03007 21.5771 5.02997Z"
        fill="#ED0006"
      />
      <path
        d="M21.5771 5.02997C25.322 5.02997 28.3584 8.02986 28.3584 11.7302C28.3583 15.4304 25.322 18.4304 21.5771 18.4304C19.8985 18.4303 18.3638 17.8253 17.1797 16.8268C18.6369 15.598 19.5624 13.7715 19.5625 11.7302C19.5625 9.6886 18.6371 7.86141 17.1797 6.63251C18.3637 5.63417 19.8986 5.03007 21.5771 5.02997Z"
        fill="#F9A000"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.1787 6.63251C18.6362 7.86141 19.5615 9.6886 19.5615 11.7302C19.5615 13.7715 18.636 15.598 17.1787 16.8268C15.7217 15.598 14.7969 13.7713 14.7969 11.7302C14.7969 9.68882 15.7215 7.8614 17.1787 6.63251Z"
        fill="#FF5E00"
      />
    </svg>
  );
}

function AmexIcon() {
  return (
    <svg
      className={BADGE_CLASS}
      viewBox="0 0 34 24"
      fill="none"
      aria-hidden="true"
    >
      <rect width="34" height="24" rx="4" fill="#1F72CD" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.09517 8.5L2.91406 15.7467H6.7223L7.19441 14.5913H8.27355L8.74566 15.7467H12.9375V14.8649L13.311 15.7467H15.4793L15.8528 14.8462V15.7467H24.5706L25.6307 14.6213L26.6232 15.7467L31.1009 15.7561L27.9097 12.1436L31.1009 8.5H26.6927L25.6608 9.60463L24.6995 8.5H15.2156L14.4013 10.3704L13.5678 8.5H9.7675V9.35186L9.34474 8.5H6.09517ZM6.83238 9.52905H8.68869L10.7987 14.4431V9.52905H12.8322L14.462 13.0524L15.964 9.52905H17.9874V14.7291H16.7562L16.7461 10.6544L14.9512 14.7291H13.8499L12.0449 10.6544V14.7291H9.51212L9.03195 13.5633H6.43778L5.9586 14.728H4.60156L6.83238 9.52905ZM24.1196 9.52905H19.1134V14.726H24.0421L25.6307 13.0036L27.1618 14.726H28.7624L26.436 12.1426L28.7624 9.52905H27.2313L25.6507 11.2316L24.1196 9.52905ZM7.73554 10.4088L6.88086 12.4855H8.58922L7.73554 10.4088ZM20.3497 11.555V10.6057V10.6048H23.4734L24.8364 12.1229L23.413 13.6493H20.3497V12.613H23.0808V11.555H20.3497Z"
        fill="white"
      />
    </svg>
  );
}

function DiscoverIcon() {
  return (
    <svg
      className={BADGE_CLASS}
      viewBox="0 0 34 24"
      fill="none"
      aria-hidden="true"
    >
      <rect x="0.5" y="0.5" width="33" height="23" rx="3.5" fill="white" />
      <rect x="0.5" y="0.5" width="33" height="23" rx="3.5" stroke="#E5E5E5" />
      <path
        d="M14 23L33 17.25V20C33 21.6569 31.6569 23 30 23H14Z"
        fill="#FD6020"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29.3937 9.11084C30.439 9.11084 31.0139 9.59438 31.0139 10.5077C31.0662 11.2062 30.5958 11.7972 29.9686 11.9046L31.3797 13.8925H30.2822L29.0801 11.9584H28.9756V13.8925H28.0871V9.11084H29.3937ZM28.9756 11.3137H29.2369C29.8118 11.3137 30.0731 11.045 30.0731 10.5615C30.0731 10.1317 29.8118 9.86304 29.2369 9.86304H28.9756V11.3137ZM25.0039 13.8925H27.5126V13.0866H25.8924V11.7972H27.4603V10.9913H25.8924V9.91674H27.5126V9.11084H25.0039V13.8925ZM22.3899 12.3345L21.1878 9.11084H20.2471L22.1809 14H22.6512L24.585 9.11084H23.6443L22.3899 12.3345ZM11.7805 11.5286C11.7805 12.8717 12.8258 14 14.1324 14C14.5505 14 14.9164 13.8925 15.2822 13.7314V12.6568C15.0209 12.9792 14.655 13.1941 14.2369 13.1941C13.4007 13.1941 12.7212 12.5494 12.7212 11.6897V11.5823C12.669 10.7227 13.3484 9.97048 14.1847 9.91675C14.6028 9.91675 15.0209 10.1317 15.2822 10.454V9.37948C14.9686 9.16458 14.5505 9.11085 14.1847 9.11085C12.8258 9.0034 11.7805 10.1317 11.7805 11.5286ZM10.1598 10.9376C9.63717 10.7227 9.48037 10.6152 9.48037 10.3466C9.53264 10.0242 9.79396 9.75557 10.1075 9.8093C10.3689 9.8093 10.6302 9.97048 10.8393 10.1854L11.3096 9.54066C10.9438 9.2183 10.4734 9.00339 10.003 9.00339C9.27131 8.94967 8.64414 9.54066 8.59187 10.2928V10.3466C8.59187 10.9913 8.8532 11.3674 9.68943 11.636C9.89849 11.6897 10.1075 11.7972 10.3166 11.9046C10.4734 12.0121 10.5779 12.1733 10.5779 12.3882C10.5779 12.7643 10.2643 13.0866 9.95075 13.0866H9.89849C9.48037 13.0866 9.11452 12.818 8.95772 12.4419L8.38281 13.0329C8.6964 13.6239 9.32358 13.9463 9.95075 13.9463C10.787 14 11.4664 13.3553 11.5187 12.4956V12.3345C11.4664 11.6897 11.2051 11.3674 10.1598 10.9376ZM7.12892 13.8925H8.01742V9.11084H7.12892V13.8925ZM3 9.11086H4.30662H4.56794C5.8223 9.16458 6.81532 10.2391 6.76306 11.5286C6.76306 12.227 6.44947 12.8717 5.92682 13.3553C5.45644 13.7314 4.88153 13.9463 4.30662 13.8926H3V9.11086ZM4.14983 13.0866C4.56794 13.1404 5.03833 12.9792 5.35191 12.7105C5.6655 12.3882 5.8223 11.9584 5.8223 11.4748C5.8223 11.045 5.6655 10.6152 5.35191 10.2928C5.03833 10.0242 4.56794 9.86302 4.14983 9.91674H3.8885V13.0866H4.14983Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.9471 9C16.6405 9 15.543 10.0745 15.543 11.4714C15.543 12.8146 16.5883 13.9429 17.9471 13.9966C19.306 14.0503 20.3513 12.9221 20.4036 11.5252C20.3513 10.1283 19.306 9 17.9471 9V9Z"
        fill="#FD6020"
      />
    </svg>
  );
}

const ROW_BADGE_CLASS = "h-8 w-[46px] flex-none";

function VisaRowIcon() {
  return (
    <svg
      className={ROW_BADGE_CLASS}
      viewBox="0 0 46 32"
      fill="none"
      aria-hidden="true"
    >
      <rect x="0.5" y="0.5" width="45" height="31" rx="5.5" fill="white" />
      <rect x="0.5" y="0.5" width="45" height="31" rx="5.5" stroke="#E5E5E5" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.3341 21.1443H11.5877L9.52833 13.0565C9.43058 12.6844 9.22304 12.3555 8.91774 12.2005C8.15584 11.811 7.31628 11.5009 6.40039 11.3446V11.0332H10.8245C11.4351 11.0332 11.893 11.5009 11.9694 12.0442L13.0379 17.8782L15.7829 11.0332H18.4529L14.3341 21.1443ZM19.9794 21.1443H17.3857L19.5214 11.0332H22.1151L19.9794 21.1443ZM25.4707 13.8343C25.547 13.2897 26.0049 12.9783 26.5392 12.9783C27.3788 12.9001 28.2933 13.0565 29.0565 13.4447L29.5145 11.2677C28.7512 10.9564 27.9117 10.8 27.1498 10.8C24.6324 10.8 22.8007 12.2005 22.8007 14.1443C22.8007 15.623 24.0982 16.3995 25.0141 16.8672C26.0049 17.3336 26.3865 17.645 26.3102 18.1114C26.3102 18.811 25.547 19.1224 24.7851 19.1224C23.8692 19.1224 22.9533 18.8892 22.1151 18.4996L21.6571 20.6779C22.573 21.0661 23.5639 21.2225 24.4798 21.2225C27.3024 21.2993 29.0565 19.9001 29.0565 17.8C29.0565 15.1553 25.4707 15.0003 25.4707 13.8343ZM38.134 21.1443L36.0746 11.0332H33.8625C33.4046 11.0332 32.9466 11.3446 32.794 11.811L28.9805 21.1443H31.6505L32.1834 19.667H35.464L35.7693 21.1443H38.134ZM34.2439 13.7561L35.0058 17.5668H32.8701L34.2439 13.7561Z"
        fill="#172B85"
      />
    </svg>
  );
}

function MastercardRowIcon() {
  return (
    <svg
      className={ROW_BADGE_CLASS}
      viewBox="0 0 46 32"
      fill="none"
      aria-hidden="true"
    >
      <rect x="0.5" y="0.5" width="45" height="31" rx="5.5" fill="white" />
      <rect x="0.5" y="0.5" width="45" height="31" rx="5.5" stroke="#E5E5E5" />
      <path
        d="M28.7695 6.7066C33.7626 6.70666 37.8105 10.7065 37.8105 15.6402C37.8104 20.5738 33.7626 24.5728 28.7695 24.5728C26.5311 24.5728 24.4842 23.7675 22.9053 22.4361C21.3264 23.7676 19.2795 24.5728 17.041 24.5728C12.0479 24.5728 8.00014 20.5738 8 15.6402C8 10.7065 12.0479 6.7066 17.041 6.7066C19.2794 6.70663 21.3264 7.51196 22.9053 8.84332C24.4842 7.512 26.5312 6.7066 28.7695 6.7066Z"
        fill="#ED0006"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.9062 22.4392C24.8502 20.8007 26.0828 18.3625 26.0828 15.6399C26.0828 12.9173 24.8502 10.4792 22.9062 8.84066C24.485 7.50993 26.5329 6.7066 28.7706 6.7066C33.7638 6.7066 37.8115 10.7062 37.8115 15.6399C37.8115 20.5737 33.7638 24.5733 28.7706 24.5733C26.5329 24.5733 24.485 23.7699 22.9062 22.4392Z"
        fill="#F9A000"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.9053 8.84363C24.8483 10.4821 26.0819 12.9178 26.082 15.6395C26.082 18.3613 24.8481 20.7969 22.9053 22.4354C20.9624 20.7969 19.7285 18.3613 19.7285 15.6395C19.7286 12.9177 20.9622 10.4821 22.9053 8.84363Z"
        fill="#FF5E00"
      />
    </svg>
  );
}

function AmexRowIcon() {
  return (
    <svg
      className={ROW_BADGE_CLASS}
      viewBox="0 0 46 32"
      fill="none"
      aria-hidden="true"
    >
      <rect width="46" height="32" rx="4" fill="#1F72CD" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.12625 11.3334L3.88477 20.9957H8.96241L9.59189 19.4551H11.0307L11.6602 20.9957H17.2493V19.8199L17.7473 20.9957H20.6384L21.1364 19.795V20.9957H32.7602L34.1736 19.4951L35.497 20.9957L41.4672 21.0081L37.2123 16.1915L41.4672 11.3334H35.5896L34.2137 12.8062L32.932 11.3334H20.2869L19.201 13.8273L18.0897 11.3334H13.0227V12.4692L12.459 11.3334H8.12625ZM9.10919 12.7054H11.5843L14.3976 19.2575V12.7054H17.109L19.282 17.4032L21.2847 12.7054H23.9825V19.6388H22.3409L22.3275 14.2059L19.9343 19.6388H18.4659L16.0592 14.2059V19.6388H12.6822L12.042 18.0844H8.58305L7.94415 19.6374H6.13477L9.10919 12.7054ZM32.1593 12.7054H25.4844V19.6347H32.0559L34.174 17.3382L36.2156 19.6347H38.3497L35.2478 16.1902L38.3497 12.7054H36.3082L34.2008 14.9755L32.1593 12.7054ZM10.3124 13.8785L9.17285 16.6475H11.4507L10.3124 13.8785ZM27.1318 15.4067V14.141V14.1398H31.2968L33.1141 16.1639L31.2162 18.1991H27.1318V16.8174H30.7733V15.4067H27.1318Z"
        fill="white"
      />
    </svg>
  );
}

function DiscoverRowIcon() {
  return (
    <svg
      className={ROW_BADGE_CLASS}
      viewBox="0 0 46 32"
      fill="none"
      aria-hidden="true"
    >
      <rect x="0.5" y="0.5" width="45" height="31" rx="3.5" fill="white" />
      <rect x="0.5" y="0.5" width="45" height="31" rx="3.5" stroke="#E5E5E5" />
      <path
        d="M25 31L44 25.25V28C44 29.6569 42.6569 31 41 31H25Z"
        fill="#FD6020"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M39.1916 12.1478C40.5853 12.1478 41.3518 12.7925 41.3518 14.0103C41.4215 14.9416 40.7943 15.7296 39.9581 15.8729L41.8396 18.5234H40.3762L38.7734 15.9445H38.6341V18.5234H37.4494V12.1478H39.1916ZM38.6341 15.0849H38.9825C39.749 15.0849 40.0975 14.7267 40.0975 14.082C40.0975 13.5089 39.749 13.1507 38.9825 13.1507H38.6341V15.0849ZM33.3379 18.5234H36.6829V17.4488H34.5226V15.7296H36.6132V14.655H34.5226V13.2223H36.6829V12.1478H33.3379V18.5234ZM29.8532 16.446L28.2504 12.1478H26.9961L29.5745 18.6667H30.2017L32.7801 12.1478H31.5257L29.8532 16.446ZM15.707 15.3714C15.707 17.1623 17.1008 18.6666 18.8429 18.6666C19.4004 18.6666 19.8882 18.5234 20.376 18.3084V16.8757C20.0276 17.3055 19.5398 17.5921 18.9823 17.5921C17.8673 17.5921 16.9614 16.7325 16.9614 15.5863V15.443C16.8917 14.2968 17.7976 13.2939 18.9126 13.2223C19.4701 13.2223 20.0276 13.5088 20.376 13.9387V12.5059C19.9579 12.2194 19.4004 12.1478 18.9126 12.1478C17.1008 12.0045 15.707 13.5088 15.707 15.3714ZM13.547 14.5834C12.8502 14.2969 12.6411 14.1536 12.6411 13.7954C12.7108 13.3656 13.0592 13.0074 13.4773 13.0791C13.8258 13.0791 14.1742 13.294 14.4529 13.5805L15.0801 12.7209C14.5923 12.2911 13.9651 12.0045 13.338 12.0045C12.3624 11.9329 11.5261 12.7209 11.4564 13.7238V13.7954C11.4564 14.6551 11.8049 15.1565 12.9198 15.5147C13.1986 15.5863 13.4773 15.7296 13.7561 15.8729C13.9651 16.0161 14.1045 16.231 14.1045 16.5176C14.1045 17.019 13.6864 17.4489 13.2683 17.4489H13.1986C12.6411 17.4489 12.1533 17.0907 11.9442 16.5892L11.1777 17.3772C11.5958 18.1652 12.432 18.595 13.2683 18.595C14.3833 18.6667 15.2892 17.807 15.3589 16.6609V16.446C15.2892 15.5863 14.9407 15.1565 13.547 14.5834ZM9.50488 18.5234H10.6896V12.1478H9.50488V18.5234ZM4 12.1478H5.74216H6.09059C7.76306 12.2194 9.0871 13.6522 9.01741 15.3714C9.01741 16.3027 8.59929 17.1623 7.90243 17.807C7.27526 18.3085 6.50871 18.595 5.74216 18.5234H4V12.1478ZM5.5331 17.4488C6.09059 17.5205 6.71776 17.3056 7.13588 16.9474C7.554 16.5176 7.76306 15.9445 7.76306 15.2998C7.76306 14.7267 7.554 14.1536 7.13588 13.7238C6.71776 13.3656 6.09059 13.1507 5.5331 13.2223H5.18466V17.4488H5.5331Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.9302 12C22.188 12 20.7246 13.4327 20.7246 15.2953C20.7246 17.0862 22.1183 18.5905 23.9302 18.6621C25.742 18.7338 27.1357 17.2294 27.2054 15.3669C27.1357 13.5044 25.742 12 23.9302 12V12Z"
        fill="#FD6020"
      />
    </svg>
  );
}

const ICONS_BY_BRAND: Record<string, () => React.ReactElement> = {
  visa: VisaIcon,
  mastercard: MastercardIcon,
  "american-express": AmexIcon,
  discover: DiscoverIcon,
};

const ROW_ICONS_BY_BRAND: Record<string, () => React.ReactElement> = {
  visa: VisaRowIcon,
  mastercard: MastercardRowIcon,
  "american-express": AmexRowIcon,
  discover: DiscoverRowIcon,
};

/** Human names for error copy and accessibility. */
export const CARD_BRAND_LABELS: Record<string, string> = {
  visa: "Visa",
  mastercard: "Mastercard",
  "american-express": "American Express",
  discover: "Discover",
};

export default function CardBrandIcon({
  brand,
  variant = "input",
}: {
  brand: string | null;
  /** `input` = the compact badge inside the card-number field; `row` =
   * the larger badge on a saved-card radio row. */
  variant?: "input" | "row";
}) {
  const icons = variant === "row" ? ROW_ICONS_BY_BRAND : ICONS_BY_BRAND;
  const Icon = brand ? icons[brand] : undefined;
  if (!Icon) {
    return (
      <span
        className={`${variant === "row" ? ROW_BADGE_CLASS : BADGE_CLASS} rounded border border-oat-200 bg-white`}
        aria-hidden="true"
      />
    );
  }
  return <Icon />;
}
